import React, { FC, useEffect, useRef, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { useCheckBreakpoint } from '../../modules';
import { canUseDOM } from '../../modules/utils/helper';
import { AccountTableProps } from './AccountTable.types';
import { AccountTableView } from './AccountTableView';

export const AccountTable: FC<AccountTableProps> = props => {
  const authorModelData = props?.model;
  const theadRef = useRef(null);
  const tableRef = useRef(null);
  const [domRendered, setDomRendered] = useState(false);

  const isDesktopAndAbove = useCheckBreakpoint('viewportL');

  useEffect(() => {
    canUseDOM && window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isDesktopAndAbove]);

  useEffect(() => {
    setDomRendered(true);
  }, [props?.model]);

  let lastScrollY = 0;
  const handleScroll = (): void => {
    const thead = theadRef.current as HTMLElement | null;
    const table = tableRef.current as HTMLElement | null;

    if (!thead || !table) return;

    const tableRect = table.getBoundingClientRect();
    const htlHeaderComp = document.querySelector('.m-header');
    const htlHeaderHeight = htlHeaderComp?.getBoundingClientRect().height ?? 0;

    const isScrollingDown = window.scrollY > lastScrollY;
    lastScrollY = window.scrollY;

    if (isScrollingDown) {
      if (tableRect.top <= 0) {
        thead.classList.add('sticky');
        thead.style.top = '0px';
      }
    } else {
      if (tableRect.top >= htlHeaderHeight) {
        thead.classList.remove('sticky');
        thead.style.top = '';
      } else {
        thead.classList.add('sticky');
        thead.style.top = `${htlHeaderHeight}px`;
      }
    }
  };

  return (
    <AccountTableView
      id={authorModelData?.id}
      variation={authorModelData?.variation}
      headerTitleItems={authorModelData?.headerTitleItems}
      rowItems={authorModelData?.rowItems}
      disclaimerText={authorModelData?.disclaimerText}
      domRendered={domRendered}
      theadRef={theadRef}
      tableRef={tableRef}
    />
  );
};

export const AccountTableConfig = {
  emptyLabel: 'AccountTable',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/accounttable`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccountTableEditable = (props: any) => {
  return props?.cqPath?.includes('datapagecomponent') ? (
    <AccountTable {...props} />
  ) : (
    <EditableComponent config={AccountTableConfig} {...props}>
      <AccountTable {...props} />
    </EditableComponent>
  );
};

export default AccountTableEditable;
